import type {
    MonitoringAlertDto,
    MonitoringHealthDto,
    ProjectBenefitReviewDto,
    ProjectMonitoringDto,
    RecordBenefitReviewDto,
} from '@paladin-monorepo/common';
import API from '../api';

export const monitoringQueryKey = (projectId: string) => ['projectMonitoring', projectId] as const;
export const monitoringHealthQueryKey = ['monitoringHealth'] as const;

export const projectMonitoringApi = {
    async get(projectId: string): Promise<ProjectMonitoringDto> {
        return API.get<ProjectMonitoringDto>(`/projects/${encodeURIComponent(projectId)}/monitoring`).then(
            (res) => res.data,
        );
    },
    async acknowledge(projectId: string, alertId: string): Promise<MonitoringAlertDto> {
        return API.post<MonitoringAlertDto>(
            `/projects/${encodeURIComponent(projectId)}/monitoring/alerts/${encodeURIComponent(alertId)}/acknowledge`,
        ).then((res) => res.data);
    },
    async recordBenefitReview(
        projectId: string,
        reviewId: string,
        dto: RecordBenefitReviewDto,
    ): Promise<ProjectBenefitReviewDto> {
        return API.post<ProjectBenefitReviewDto>(
            `/projects/${encodeURIComponent(projectId)}/monitoring/benefit-reviews/${encodeURIComponent(reviewId)}`,
            dto,
        ).then((res) => res.data);
    },
    async health(): Promise<MonitoringHealthDto> {
        return API.get<MonitoringHealthDto>('/monitoring/health').then((res) => res.data);
    },
};
